import React, { useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "../Loader/Loader";

const OTPField = ({
  isOpen = false,
  errorMessage,
  isLoading,
  onSubmit = () => {},
  onHide = () => {},
}) => {
  const [otp, setOtp] = useState("");
  const otpField = useRef(null);
  return (
    <Modal
      centered
      show={isOpen}
      onShow={() => {
        if (otpField.current !== null) {
          otpField.current.focus();
        }
      }}
      onHide={onHide}
    >
      <Modal.Body className="text-center">
        <h1>OTP</h1>
        <input
          ref={otpField}
          className="form-control"
          type="tel"
          name="rfid"
          id="rfid"
          value={otp}
          onChange={(event) => setOtp(event.target.value)}
          onBlur={() => {
            if (otpField.current !== null) {
              otpField.current.focus();
            }
          }}
          inputMode="numeric"
          autoComplete="off"
          autoFocus
          disabled={isLoading}
        />
        <Button
          variant={"success"}
          onClick={() => onSubmit(otp)}
          className="mt-2"
          disabled={isLoading}
        >
          Submit
        </Button>

        {errorMessage && (
          <p className="text-danger" style={{ fontSize: 32 }}>
            {errorMessage} <br />
          </p>
        )}
        {isLoading && <Loader />}
      </Modal.Body>
    </Modal>
  );
};

export default OTPField;
